<template>
    <div :class="['content-container', 'ipad', {'desktop': !this.isIpad}]">

        <NavBar title="App Config"></NavBar>

        <!-- Content -->
        <div class="container config-container">

            <section class="card">
                <div class="card-header bg-transparent">
                    <h3>App Homepage</h3>
                </div>
                <div class="card-body pb-0">
                    <form>
                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input class="custom-control-input" :checked="appHomepageStatus" type="checkbox" name="show-disclaimer" id="homepage-status" v-on:change="setAppHomepageStorage">
                                <label class="custom-control-label" for="homepage-status">
                                    App homepage is {{ currentAppHomepage}}
                                </label>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="card-header mt-0 bg-transparent">
                    <h3>Event Management</h3>
                </div>
                <div class="card-body pb-0">
                    <form>
                        <div class="row">
                            <div v-for="event in events" class="col-6 py-2" :key="event.name[0].value">
                                <div class="custom-control custom-switch">
                                <input class="custom-control-input" v-on:change="setStorage" :id="event.name[0].value | hyphenate" type="radio" :value="event" v-model="selectedEvent">
                                    <label class="custom-control-label" :for="event.name[0].value | hyphenate">{{event.name[0].value}}</label>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="card-header mt-0 bg-transparent">
                    <h3>Disclaimer Management</h3>
                </div>
                <div class="card-body">
                    <form>
                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input class="custom-control-input" :checked="disclaimerStatus" type="checkbox" name="show-disclaimer" id="disclaimer-status" v-on:change="setDisclaimerStorage">
                                <label class="custom-control-label" for="disclaimer-status">
                                    Hide Disclaimer
                                </label>
                            </div>
                        </div>
                    </form>
                </div>
            </section>

        </div>

         <!-- Background Image -->
        <div class="img-bg">
            <img src="img/backgrounds/timeline-bg.jpg" class="bottom-center">
        </div>
    </div>
</template>



<script>

    import NavBar from './components/NavBar.vue';

    export default {
        name: 'Config',
        components: {
            NavBar
        },
        data: function() {
            return {
                allowedProducts: [],
                currentAppHomepage: 'Default Homepage',
                appHomepageStatus: false,
                selectedEvent: null,
            }
        },
        filters: {
            hyphenate: function(str) {
                return str.replace(' ', '-');
            }
        },
        watch: {
            selectedEvent: {
                deep: true,
                handler(selectedEvent) {
                    this.$store.dispatch('setEventId', selectedEvent.tid[0].value);
                }
            }
        },
        mounted: function(){
            if(window.localStorage.getItem('appHomepageStatus') !== null) {
                //timeline selected
                this.appHomepageStatus = true;
                this.currentAppHomepage = 'Timeline';
            } else {
                this.appHomepageStatus = false;
                this.currentAppHomepage = 'Default Homepage';
            }
            if (this.$store.getters.getEvent) {
                this.selectedEvent = this.$store.getters.getEvent;
            }
        },
        computed: {
            appHomepage() {
                return '';
            },
            configJson: function() {
                return true
            },
            allProductNames: function() {
                return this.manageStorageProducts();
            },
            disclaimerStatus: function() {
                return this.getDisclaimerStatus();
            },
            events: function () {
                return this.$store.getters.getEvents;
            }
        },
        methods: {
            setStorage: function() {

                let options = document.querySelectorAll('[name="allowed_products[]"]');
                console.log("Options", options)
                let settings = [];


                for(let i=0; i<options.length; i++){
                    if( !options[i].checked ) {
                        settings.push(options[i].value);
                    }
                }

                window.localStorage.setItem('storageProducts', JSON.stringify(settings));
            },
            setAppHomepageStorage: function(event) {
                let homepageStatus = event.target.checked;

                if(!homepageStatus) {
                    window.localStorage.removeItem('appHomepageStatus');
                    this.currentAppHomepage = 'Default Homepage';
                    this.appHomepageStatus = false;
                } else {
                    window.localStorage.setItem('appHomepageStatus', 'timeline');
                    this.currentAppHomepage = 'Timeline';
                    this.appHomepageStatus = true;
                }
            },
            setDisclaimerStorage: function(event) {
                let disclaimer = event.target.checked;

                if(!disclaimer)
                {
                    window.localStorage.removeItem('disclaimer');
                } else {
                    window.localStorage.setItem('disclaimer', true);
                }
            },
            getDisclaimerStatus: function() {
                let disclaimer = window.localStorage.getItem('disclaimer');

                if(disclaimer === null)
                {
                    return false;
                }

                return true;
            },
            manageStorageProducts: function() {
                let storageProducts = window.localStorage.getItem('storageProducts');
                let productNames = this.$store.getters.getProductNames;
                let returnData = productNames;

                for(let i = 0; i< returnData.length; i++) {
                    var stringValue = returnData[i].nid[0].value.toString();

                    let isChecked = false;
                    if (storageProducts !== null){
                        let storageJson = JSON.parse(storageProducts);
                        if( storageJson.indexOf( stringValue ) > -1) {
                            isChecked = false;
                        } else {
                            isChecked = true;
                        }
                    } else {
                        isChecked = true;
                    }


                    Object.defineProperty(returnData[i], 'isChecked', {
                        value: isChecked,
                        configurable: true,
                        writable: true,
                    });
                }
                return returnData;
            }
        }
    }
</script>

<style scoped>

    .card {
        margin-bottom: 24px;
    }

    .card-header h2 {
        margin: 0;
    }

    .content-container .container {
        overflow-y: auto;
    }
    .config-container .card-body {
      flex: 0 1 auto;
    }
</style>